import Vue from 'vue'
import Router from 'vue-router'
import common from '@/assets/js/Common';
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(Router)
Vue.use(ToastPlugin)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}


import Login from '@/views/login/login'
import LoginWx from '@/views/login/loginWx'
import Register from '@/views/login/register'
import Debug from '@/views/login/debug'
import Test from '@/views/test'

import PageModule from './page';


import ContractModule from './contract';


import MemberModule from './member';


const routers = new Router({
mode: 'history',
routes: [

...PageModule,
...ContractModule,
...MemberModule,

{path: '/login', name: 'login', component: Login, meta: {login:1},},
{path: '/loginWx', name: 'loginWx', component: LoginWx, meta: {login:1},},
{path: '/register', name: 'register', component: Register, meta: {login:1},},
{path: '/debug', name: 'debug', component: Debug, meta: {login:1},},
{path: '/test', name: 'test', component: Test, meta: {login:1},},
{path: '*', redirect: '/'},
]
})


routers.beforeEach((to, from, next) => {

const info = common.storageJson("userInfo") || {};


if(!to.meta.login && !info.user_id){
Vue.$vux.toast.text("请先登录！！","top");
next("/login");
}

if(to.name !== 'address' && info.no_addr===1){
Vue.$vux.toast.text('需要填写收货地址!','top');
next("/member/address");
}else{
next();
}
});

export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js